import React from 'react'
import { useFetchUsersQuery, useUpdateUserMutation } from '../../../../../store/apis/user.api'
import UserForm from '../UserForm'
import { openNotificationWithIcon } from '../../../../../utils/notification.helper'
import { useSelector } from 'react-redux'
import { fetchUsersSelectors } from '../../../../../store/apis/utils/selectors/user.api.selectors'
import userSelectors from '../../../../../store/selectors/user.selectors'
import { useFetchOrganizationsQuery } from '../../../../../store/apis/organization.api'
import useAuthorization from '../../../../../components/authorization/useAuthorization'
import UserRoles, { UserTypes } from '../../../../../constants/UserRoles'

const EditUserForm = ({ onSuccess }) => {
    const editingUserId = useSelector(userSelectors.editingUserId)
    const { isAuthorized: isSystemAdmin } = useAuthorization([UserRoles.ADMIN], [UserTypes.SYSTEM_ADMIN])

    const { data: user } = useFetchUsersQuery(
        { organizationOnly: !isSystemAdmin },
        { selectFromResult: result => fetchUsersSelectors.byId({ id: editingUserId }, result) },
    )

    const [updateUser, updateUserResult] = useUpdateUserMutation()
    const { data: organizations, isFetching: isFetchingOrganizations } = useFetchOrganizationsQuery(null, { skip: !isSystemAdmin })

    const handleUpdateUser = async values => {
        const response = await updateUser({ id: user.id, ...values })

        if ('data' in response) {
            openNotificationWithIcon('success', 'Saved successfully')
            onSuccess && onSuccess()
        }
    }

    const fieldsToHide = ['email', 'password']
    if (!isSystemAdmin) fieldsToHide.push('organizationId')

    return (
        <UserForm
            organizations={organizations}
            isFetchingOrganizations={isFetchingOrganizations}
            onSubmit={handleUpdateUser}
            loading={updateUserResult.isLoading}
            error={updateUserResult.error}
            fieldsToHide={fieldsToHide}
            actionName='Save'
            initialValues={{
                name: user?.name,
                email: user?.email,
                organizationId: user?.organizationId,
                roles: user?.roles,
                type: user?.type,
                status: user?.status,
            }}
        />
    )
}

export default EditUserForm
